var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "correct",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a9b3f5eb-6c36-4d8a-90d7-34fca68baff2,.ac1bb97f-de50-4332-9f60-36d4a258e5f4{fill:#47568c;}.aabbc5ed-a6de-4255-b912-7aa14e2bcb7b{fill:#29376d;}.ebb2b716-982c-493c-b583-e6157e6d30f3{fill:#b28b67;}.b9d81119-4ba7-4758-90f7-9b6a1ab69468{fill:#ffc539;}.ac1bb97f-de50-4332-9f60-36d4a258e5f4{fill-opacity:0.8;}.af595184-2660-40b3-b473-3d213a01228f{fill:none;stroke:#815832;stroke-opacity:0.5;}.ec77e2d3-719f-4c89-9859-6ca6d4c1b943{fill:#6be62e;}.bcd237c4-5199-40d2-b6ea-6596a4137e7f{fill:#44cc29;}.b8bb6012-94f9-4f04-90fc-56368db1eb22{fill:#edf5ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b6d9580b-d0a9-4138-ac26-95524288b186",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a951dec3-7b21-4d44-8276-a4dfd15194ed",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a9b3f5eb-6c36-4d8a-90d7-34fca68baff2",
    d: "M59.9,35.16h-9V52.93l-6,5.86v5.86h24V35.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aabbc5ed-a6de-4255-b912-7aa14e2bcb7b",
    d: "M59.9,35.16h9V64.65h-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ebb2b716-982c-493c-b583-e6157e6d30f3",
    d: "M68.89,58.79h-18V52.93A14.92,14.92,0,0,0,36.24,64.65H18v30.2L24,100H68.89a14.83,14.83,0,0,0,15-14.65V73.44A14.83,14.83,0,0,0,68.89,58.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ebb2b716-982c-493c-b583-e6157e6d30f3",
    d: "M83.86,85.35V73.44a14.83,14.83,0,0,0-15-14.65h-9V100h9A14.83,14.83,0,0,0,83.86,85.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b9d81119-4ba7-4758-90f7-9b6a1ab69468",
    d: "M24,90a10,10,0,0,1-10,10H0V58.79H14a10,10,0,0,1,10,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac1bb97f-de50-4332-9f60-36d4a258e5f4",
    d: "M12,73.44a2.93,2.93,0,0,1,2.93-2.93H15a2.93,2.93,0,0,1,0,5.86h-.13A2.93,2.93,0,0,1,12,73.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "af595184-2660-40b3-b473-3d213a01228f",
    x1: 83.19,
    y1: 71.09,
    x2: 76.17,
    y2: 71.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "af595184-2660-40b3-b473-3d213a01228f",
    x1: 83.19,
    y1: 76.97,
    x2: 76.17,
    y2: 76.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "af595184-2660-40b3-b473-3d213a01228f",
    x1: 83.19,
    y1: 82.85,
    x2: 76.17,
    y2: 82.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "af595184-2660-40b3-b473-3d213a01228f",
    x1: 83.19,
    y1: 88.74,
    x2: 76.17,
    y2: 88.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "ec77e2d3-719f-4c89-9859-6ca6d4c1b943",
    d: "M60,46.87c13.23,0,24-10.49,24-23.43S73.27,0,60,0s-24,10.49-24,23.44S46.81,46.87,60,46.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcd237c4-5199-40d2-b6ea-6596a4137e7f",
    d: "M84,23.44C84,10.49,73.27,0,60,0V46.87C73.27,46.87,84,36.38,84,23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b8bb6012-94f9-4f04-90fc-56368db1eb22",
    d: "M69,13.43l-9,8.79-3,2.93-6-5.86-4.24,4.15,10.23,10,3-2.93L73.26,17.58Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.ab2f667e.svg";
export { ForwardRef as ReactComponent };